import React, { useCallback, useContext, useEffect } from "react";
import { useState } from "react";
import { LoadingContext } from "../../../App";
import * as quotationsApi from "@api/quotationsApi";
import { Breadcrumb, Button, Card, Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import NotyfContext from "../../../contexts/NotyfContext";
import { useNavigate, useParams } from "react-router-dom";

export const QuotationPreview = () => {
    // eslint-disable-next-line
    const [isLoadingActive, setIsLoadingActive] = useContext(LoadingContext);
    const notyf = useContext(NotyfContext);
    const navigate = useNavigate();
    const [quotation, setQuotations] = useState();
    const { id } = useParams();

    const getQuotations = useCallback(
        async (param = null) => {
            try {
                setIsLoadingActive(true);
                const response = await quotationsApi.previewQuotation(
                    id,
                    param
                );
                if (response.status === 200) {
                    setQuotations(response.data);
                    setIsLoadingActive(false);
                }
            } catch (error) {
                notyf.open({
                    type: "danger",
                    message: error?.message,
                });
                setIsLoadingActive(false);
            }
        },
        // eslint-disable-next-line
        [notyf, setIsLoadingActive]
    );

    useEffect(() => {
        getQuotations();
    }, [getQuotations]);

    return (
        <>
            <Helmet title="Quotation preview" />
            <Container fluid className="p-0">
                <Row>
                    <Col md={6}>
                        <h4 className="h4 mb-3">Add quotation items</h4>
                    </Col>
                    <Col md={6}>
                        <Breadcrumb>
                            <Breadcrumb.Item
                                onClick={() =>
                                    navigate(
                                        `/works-order/quotation-list/${id}`
                                    )
                                }
                            >
                                Quotation
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>Preview</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>
                <Card>
                    <Card.Body>
                        <Row className="justify-content-center">
                            <Col
                                md={10}
                                dangerouslySetInnerHTML={{ __html: quotation }}
                            ></Col>
                        </Row>

                        <Row className="pt-4">
                            <Col md={12} className="text-center">
                                <Button
                                    variant="link"
                                    onClick={() =>
                                        navigate(
                                            `/works-order/quotation-list/${id}`
                                        )
                                    }
                                >
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Container>
        </>
    );
};
